<template>
  <div class="dialog-mask payment-method-dialog" :class="{ open: isOpen }">
    <div class="dialog-content">
      <!-- <div class="dialog-header" v-if="title">{{title}}</div> -->
      <!-- <div class="dialog-body" v-if="loading">
        Caricamento...
      </div> -->
      <div class="dialog-body"><!-- v-else -->
        <template v-if="methods.length">
        <p>{{ 'ChooseASavedCreditCard' | lang }}</p>
        <ul class="nav">
          <li v-for="(method, idx) in methods" :key="idx" v-clickspace="() => select(method)">
            <span>
              <i class="fa fa-fw fa-check-square-o" v-if="selected && selected.Token === method.Token"></i>
              <i class="fa fa-fw fa-square-o" v-else></i>
              &nbsp;{{method.Description}}
            </span>
            <timed-button v-on:confirm="deleteThisPayment(method, idx)" style="float:left;margin-right:1px" />
          </li>
        </ul>
        <br />
        <p>{{ 'OrUseANewCard' | lang }}</p>
        <br />
        </template>
        <ul class="nav">
          <li v-clickspace="() => select('save')">
            <span>
              <i class="fa fa-fw fa-check-square-o" v-if="selected === 'save'"></i>
              <i class="fa fa-fw fa-square-o" v-else></i>
              &nbsp;{{ 'SaveNewCard' | lang }}
            </span>
          </li>
          <li v-clickspace="() => select('notsave')">
            <span>
              <i class="fa fa-fw fa-check-square-o" v-if="selected === 'notsave'"></i>
              <i class="fa fa-fw fa-square-o" v-else></i>
              &nbsp;{{ 'DontSaveCard' | lang }}
            </span>
          </li>
          <!-- <li v-clickspace="() => sweetClose('notsave')">Prosegui senza salvare</li> -->
        </ul>
      </div>
      <div class="dialog-footer">
        <button @click="sweetClose(selected)">{{ 'Pay' | lang }}</button>
        <button @click="sweetClose()">{{ 'Undo' | lang }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import dialogMixin from '@/mixins/dialogMixin'
import paymentServices from '@/mixins/services/paymentServices'
import TimedButton from '@/components/TimedButton'

export default {
  name: 'CartPaymentMethodDialog',
  mixins: [ dialogMixin, paymentServices ],
  components: { TimedButton },
  props: ['methods'],
  data () {
    return {
      selected: null // 'notsave'
      // loading: false,
      // methods: []
    }
  },
  computed: {},
  methods: {
    select (method) {
      // if (method === this.selected) {}
      this.selected = method
    },
    deleteThisPayment (method, idx) {
      this._deletePaymentMethod(method.Token).then(() => {
        this.methods.splice(idx, 1)
        if (this.selected.Token === method.Token) {
          this.autoselect()
        }
      }).catch(err => {
        console.error(err)
      })
    },
    autoselect () {
      let token = localStorage.getItem('lastPaymentToken')
      if (token && token !== 'null') {
        let m = this.methods.filter(m => m.Token === token).shift()
        if (m) {
          this.selected = m
        }
      }
      if (!this.selected) {
        this.selected = this.methods.length ? this.methods[0] : 'notsave'
      }
    }
    /* getPaymentMethods () {
      this.loading = true
      this._getPaymentMethods().then(data => {
        this.methods = data
        this.loading = false
      }).catch(err => {
        console.error(err)
        this.loading = false
      })
    } */
  },
  mounted () {
    // this.getPaymentMethods()
    this.autoselect()
  }
}
</script>

<style lang="scss">
@import '@/assets/_vars.scss';

</style>
